import { type IRole } from '@/app/types/authType'
import { onSetMainRole } from '@/app/utils/onSetMainRole'
import { Divider } from '@/shared'
import { ROLE_MAPPER } from '@Config/config'

import { type IDropItem } from './helper'
import { Item } from './Item/Item'
import style from './UserDropMenu.module.scss'

interface IProps {
    onLogout: () => void
    onOpenChangePasswordModal: () => void
    roles: IRole[]
    login: string
}

const onFilterRules = (allowedRoles: IRole[], userRoles: IRole[]) =>
    userRoles.map((el) => el.role).filter((element) => !allowedRoles.map((el) => el.role).includes(element)).length < 1

export const UserDropMenu = (props: IProps) => {
    const { onLogout, onOpenChangePasswordModal, roles, login } = props

    const { SADMN, RADMN, DMSMR, UNKNOWN } = ROLE_MAPPER

    const onChangePassword = () => {
        onOpenChangePasswordModal()
    }

    const onExit = () => {
        onLogout()
    }

    const items: IDropItem[] = [
        {
            title: 'Сменить пароль',
            callback: onChangePassword,
            color: 'black',
            dataLocator: 'change-password-btn',
            allowedRoles: [RADMN, DMSMR, UNKNOWN]
        },
        {
            title: 'Выход',
            callback: onExit,
            color: 'blue',
            dataLocator: 'logout-btn',
            allowedRoles: [RADMN, SADMN, DMSMR, UNKNOWN]
        }
    ]
    return (
        <div className={style.container}>
            <div className={style.userData}>
                <div className={style.role} data-locator={'admin-role'}>
                    <span>{onSetMainRole(roles).roleDescription}</span>
                </div>
                <div className={style.login} data-locator={'admin-login'}>
                    <span>{login}</span>
                </div>
            </div>
            <Divider />
            {items
                .filter((item) => onFilterRules(item.allowedRoles, roles))
                .map((item) => {
                    const { title } = item
                    return <Item key={title} {...item} />
                })}
        </div>
    )
}
